export default class UserCompanyConsentTerm {
  
    constructor() {
        this.userId = "";
        this.companyId = "";
        this.ipAddress = "";
        this.accepted = false;
    }

}